import React from 'react'
import { CheckboxProps } from '@components/Checkbox/interface'

const withCheckbox = (Component: React.FC<CheckboxProps>) => {
  function Hoc(props: CheckboxProps) {
    return <Component {...props} />
  }
  return Hoc
}

export { withCheckbox }
